'use client';

import { CTACard } from '@/components/CTACard';
import { SpaceWow } from '@/components/SpaceWow';
import openChat from '@/helpers/hubspot/openChat';

export default function CTA_ChatCompact() {
	return (
		<CTACard
			testId="CTA_ChatCompact"
			type="button"
			compact
			color="sky"
			onClick={() => openChat()}
		>
			<div className="px-6 py-4">
				<CTACard.Badge color="sky" compact>
					Live Chat
				</CTACard.Badge>
				<SpaceWow spacer_02 />
				<CTACard.Title compact className="pb-0.5">
					Chat with an Advisor
				</CTACard.Title>
				<CTACard.Content compact className="pb-2">
					Have an HVAC question? Our experts are here to help!
				</CTACard.Content>
				<CTACard.Action color="sky" compact>
					Get help now
				</CTACard.Action>
			</div>
		</CTACard>
	);
}
